import { setCurrentSeer } from './proxify-state'
import { StatefulCbInstanceSeer } from './Seer'

/** @type {guest.maurice.setupClassSeers} */
export const setupClassSeers = (classified, classesInfo, instance) => {
  const { classes } = instance
  const pd = Object.getOwnPropertyDescriptors(classesInfo)
  const realClassesInfo = {}
  for (const p in pd) {
    Object.defineProperty(realClassesInfo, classes[p] || p, pd[p])
  }

  const classSeer = new StatefulCbInstanceSeer()
  classSeer.enableHoarding = false
  classSeer.instance = instance
  const { classList } = classified
  if (!classList) return
  let hoard = null
  for (const cl in realClassesInfo) {
    const { get } = Object.getOwnPropertyDescriptor(realClassesInfo, cl)
    const cb = () => {
      // possibly hoard
      /** @suppress {checkTypes} */
      const shouldHaveClass = get.call(instance)
      if (!hoard) {
        hoard = {}
        setTimeout(() => {
          for (const key in hoard) {
            const val = hoard[key]
            if (val) classList.add(key)
            else classList.remove(key)
          }
          hoard = null
        }, 1)
      }
      if (shouldHaveClass) {
        hoard[cl] = true
      } else hoard[cl] = false
    }
    setCurrentSeer(classSeer, cb)
    cb()
    setCurrentSeer(null)
  }
}

/** @type {guest.maurice.setupClassSeersDelayed} */
export function setupClassSeersDelayed(el, classesInfo, instance) {
  if (!el) return
  setTimeout(() => {
    setupClassSeers(el, classesInfo, instance)
  }, 1)
}

// if (window['MAURICE_ENABLE_DEBUG']) {
//   console.log('Updating classes for ', element)
//   let s = ''
//   if (add.length) s += 'Adding "' + add.join(' ') + '" '
//   if (remove.length) s += 'Removing "' + remove.join(' ') + '"'
//   console.log(s)
// }